import { useEffect, useState } from "react";
import { useMaintenanceFlagEntry } from "./maintenance";
import { UseQueryResult } from "@tanstack/react-query";

const useFlagsQuery = <R, T>(
  useQuery: () => UseQueryResult<T>,
  parse: (data: T | undefined) => R,
) => {
  const { data, refetch, isLoading } = useQuery();
  const [flags, setFlags] = useState<Partial<R>>({});

  useEffect(() => {
    isLoading || setFlags(parse(data));
  }, [data, isLoading]);

  return { flags, check: () => refetch() };
};

export const useMaintenanceFlagsQuery = () =>
  useFlagsQuery(useMaintenanceFlagEntry, (data) => ({
    enableMaintenance: data?.games?.BTY?.enabled ?? false,
    message: data?.games?.BTY?.maintenanceMessage ?? '',
    allowedUsers: data?.allowedUsers ?? [],
  }));

export const useAnnouncementFlagsQuery = () =>
  useFlagsQuery(useMaintenanceFlagEntry, (data) => ({
    showAnnouncement: !!data?.games?.BTY?.announcementEnabled,
    announcementMessage: data?.games?.BTY?.maintenanceAnnouncement ?? '',
  }));